<template>
  <div
    class="flex overflow-x-clip"
    :class="{
      'pb-20 md:pb-0': sidebarShow
    }"
  >
    <LayoutSidebar v-if="sidebarShow" />
    <LayoutNavbar v-if="sidebarShow" />
    <UiContainer class="overflow-hidden">
      <NuxtPage />
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
  const route = useRoute()

  const sidebarShow = ref(true)

  sidebarShow.value = !route.query.sidebarHide

  useHead({
    bodyAttrs: {
      class: !sidebarShow.value && "bg-transparent"
    }
  })
</script>

<style scoped></style>
